module.exports = "./img/84be9c4c60e5bee126c788e042e805b2.png";